export const Text = {
  fontSize: '1.4rem',
  fontWeight: '400',
  letterSpacing: '0.1rem',
  padding: '0',
  margin: '0',
  minWidth: 'auto',
  minHeight: 'auto',
};

export const HeaderText = {
  fontSize: '1.8rem',
  fontWeight: '700',
  letterSpacing: '0.1rem',
  padding: '0',
  margin: '0',
  minWidth: 'auto',
  minHeight: 'auto',
};

export const CloseBox = {
  height: '100%',
  minWidth: 'auto',
  minHeight: 'auto',
  padding: '0',
  cursor: 'pointer',
};
